import { API_BASE_URL } from "../../constants/index";
import { buildUrl } from "../../utilities/index";
import HttpInterface from "../../helpers/HttpInterface";

export class LocationsService {
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  all(params = {}) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      buildUrl(`${API_BASE_URL}/registry-service/locations`, params),
      requestOptions
    );
  }

  get(id) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/registry-service/locations/${id}`,
      requestOptions
    );
  }

  create(location) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(location),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/registry-service/locations`,
      requestOptions
    );
  }

  edit(location) {
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify(location),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/registry-service/locations/${location.id}`,
      requestOptions
    );
  }

  delete(id) {
    const requestOptions = {
      method: "DELETE",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/registry-service/locations/${id}`,
      requestOptions
    );
  }
}
